import { getFlightsTimerExpirationTimestamp } from 'components/Flights/FlightsSessionTimer/FlightsSessionTimer'
import config from 'constants/config'
import moment from 'moment'

export function getRemainingFlightSessionTime(): { minutes: number, seconds: number } {
  const expirationTimestamp = getFlightsTimerExpirationTimestamp()
  const currentTimestamp = moment().toDate().getTime()
  const totalTimeRemainingInSeconds = moment(expirationTimestamp).diff(currentTimestamp, 'seconds')

  if (totalTimeRemainingInSeconds <= 0) {
    return { minutes: 0, seconds: 0 }
  }

  // calculate remaining minutes
  const minutesRemaining = (Math.floor(totalTimeRemainingInSeconds / 60))

  // calculate remaining seconds
  const minutesRemainingInSeconds = minutesRemaining * 60
  const secondsRemaining = totalTimeRemainingInSeconds - minutesRemainingInSeconds

  return { minutes: minutesRemaining, seconds: secondsRemaining }
}

export function shouldRenderFlightSessionCountdownClock(hasFlightsInCheckout: boolean) {
  return config.ENABLE_FLIGHTS_SESSION_TIMER && hasFlightsInCheckout
}
